// Ties the requests of one run (staged uploads, CSV import, Send all, AI personalize all) into one activity entry.
export const newBatchId = () =>
  (window.crypto?.randomUUID && window.crypto.randomUUID()) ||
  `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
